import { Main } from "../components/consent-information-transfer/Main";
    import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/* 
承諾情報移管申請画面
*/
const ConsentInformationTransfer = () => {
    //権限制御
    useAuthenticationHook(PERMISSIONS.MASTER_EDIT);
    return (
        <SpaceBetween size="l">
            <Main />
        </SpaceBetween>
    );
};

export default ConsentInformationTransfer;